import baseControllerInput, { BaseController } from './baseControllerInput'

/** Initializes a controller to get the state of the hidden input field with the Jornaya LeadiD token. */
export default function buildControllerTcpa({ input }): BaseController {
  return baseControllerInput({
    // Never show an error since this is a hidden input field.
    getErrorMessage: () => ''
  })({ input })
}
